import useTranslate from '@/hooks/use-translate'
import * as Yup from 'yup'
import { MAX_DOSSIER_NAME_LENGTH } from '@/constants/NameLengths'

/**
 * Schéma de validation du wizard (TEC-1601) : contrairement à l'ancienne
 * modale, l'agence est pré-remplie et optionnelle, tandis que le type de
 * déclaration est toujours requis (cf. desktop/design_handoff_wizard).
 */
export default () => {
  const { t: tUpload } = useTranslate('upload')

  return Yup.object().shape({
    files: Yup.array()
      .min(1, tUpload('warningOnNumberFilesMinimum'))
      .required(tUpload('requiredFiles')),
    recordName: Yup.string()
      .required(tUpload('requiredRecordName'))
      .max(MAX_DOSSIER_NAME_LENGTH, tUpload('warningOnRecordNameLength')),
    agentic: Yup.boolean(),
    exportConfiguration: Yup.string().when('agentic', {
      is: true,
      then: (schema) => schema,
      otherwise: (schema) => schema.required(tUpload('requiredDeclarationType')),
    }),
    workflow: Yup.string(),
    group: Yup.string(),
    clientOrganizationId: Yup.string(),
  })
}
